import { module } from 'angular';
import { TERRAFORM_STAGE } from './stage/terraformStage';
import './terraform.help';

export const TERRAFORM_MODULE = 'spinnaker.terraform';

module(TERRAFORM_MODULE, [TERRAFORM_STAGE]);
